export function optionIsInCart(option, cartItems) {
  return (
    Object.values(cartItems).filter(
      (c) => option.type === 'accessory-product' && String(c.id) === String(option.accessory_product)
    ).length > 0
  )
}
